{
  "common": {
    "save": "Зберегти",
    "cancel": "Скасувати",
    "delete": "Видалити",
    "edit": "Редагувати",
    "search": "Пошук",
    "loading": "Завантаження...",
    "yes": "Так",
    "no": "Ні",
    "language": "Мова",
    "settings": "Налаштування",
    "logout": "Вийти",
    "today": "Сьогодні",
    "yesterday": "Вчора",
    "saved": "Збережено"
  },
  "sidebar": {
    "dashboard": "Огляд",
    "newOrder": "Нове замовлення",
    "kitchen": "Кухня",
    "restaurant": "Ресторан",
    "products": "Продукти",
    "employees": "Працівники"
  },
  "profile": {
    "title": "Мій профіль",
    "firstName": "Ім'я",
    "lastName": "Прізвище"
  },
  "attendance": {
    "arrive": "Прихід",
    "leave": "Вихід"
  }
}
